/**
 * `tech-radar` frontend module — overrides the tech-radar plugin's data API.
 *
 * The `@backstage-community/plugin-tech-radar/alpha` plugin already provides the
 * `/tech-radar` page (with a MapIcon sidebar nav item) and a default data API.
 * We attach a module to that SAME pluginId carrying an ApiBlueprint extension
 * for `techRadarApiRef`; because it resolves to the same extension id
 * (`api:tech-radar`), it overrides the plugin's default API with our curated
 * PyranaTechRadarApi. The page itself is contributed by the plugin (added in
 * App.tsx); this module only swaps the data source.
 */
import {
  ApiBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { techRadarApiRef } from '@backstage-community/plugin-tech-radar';
import { PyranaTechRadarApi } from './PyranaTechRadarApi';

const pyranaTechRadarApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: techRadarApiRef,
      deps: {},
      factory: () => new PyranaTechRadarApi(),
    }),
});

export const techRadarModule = createFrontendModule({
  pluginId: 'tech-radar',
  extensions: [pyranaTechRadarApi],
});
